module.exports = __webpack_public_path__ + "static/media/mona.2dbfb37c.svg";